import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import Modal from 'components/Modal';
import { forEach as _forEach, isArray as _isArray } from 'lodash';

class FiltersetNew extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filtersetInput: '',
      filters: { ...props.filters },
    };
  }

  saveButtonClicked = filtersetName => {
    const { onSaveButtonClicked } = this.props;
    const { filters } = this.state;

    if (onSaveButtonClicked) {
      onSaveButtonClicked(filtersetName, filters);
    }
  };

  // remove a value from array
  removeArrayFilter = (name, value) => {
    const { filters } = this.state;

    const values = filters[name].slice();
    values.splice(values.indexOf(value), 1);
    filters[name] = values;
    this.setState({ filters });
  };

  listFilters = () => {
    const result = [];
    _forEach(this.state.filters, (values, name) => {
      if (_isArray(values)) {
        _forEach(values, (value, j) => {
          result.push(
            <li
              onClick={() => this.removeArrayFilter(name, value)}
              class="pull-left m-r-10 m-b-10 fs-10"
              key={name + j}
            >
              <a
                href="javascript:;"
                onClick={() => this.removeArrayFilter(name, value)}
                class="p-l-10 p-r-10 p-t-5 p-b-5 bg-master-lighter"
              >
                {this.getFilterName(name)}: {this.getFilterValue(name, value)}{' '}
                <span class="m-l-10">
                  <i class="fa fa-times" />
                </span>
              </a>
            </li>
          );
        });
      }
    });

    if (!result.length) {
      return <span>Keine vorhanden</span>;
    }
    return (
      <ul class="p-t-10 list-unstyled summary-filter-tags-list" style={{ display: 'inline' }}>
        {result}
      </ul>
    );
  };

  getFilterName = name => {
    const {
      intl: { messages },
    } = this.props;

    const mapping = {
      salesmanLastname: messages.sad.salesman,
      salesmanId: messages.sad.salesman,
      salesmanIdBlacklist: messages.sad.salesman_blacklist,
      carModelName: messages.car + '-' + messages.sad.class,
      salesDescriptionShort: messages.car + '-' + messages.model,
      carTypeName: messages.sad.body_design,
      carColor: messages.sad.car_color,
      companyMainNumber: messages.company,
      salesmanCompanyNumber: messages.sad.store,
      year: messages.year,
      month: messages.month,
      status: messages.status,
      source: messages.source,
      isInternalActivity: messages.sad.internal_activity,
    };

    if (mapping.hasOwnProperty(name)) {
      return mapping[name];
    }
    return name;
  };

  getFilterValue = (name, value) => {
    const {
      intl: { messages },
    } = this.props;

    let mapping = {};
    if (name === 'status') {
      mapping = {
        100: messages.sad.offer_made,
        300: messages.sad.in_progress,
        500: messages.sad.predecessor_offer,
        700: messages.sad.lost,
        900: messages.sad.ordered,
        950: messages.sad.canceled,
      };
    } else if (name === 'isInternalActivity') {
      mapping = {
        true: messages.yes,
        false: messages.no,
      };
    }

    if (mapping.hasOwnProperty(value)) {
      return mapping[value];
    }
    return value;
  };

  render() {
    const {
      intl: { messages },
      show,
      close,
      formStatus,
    } = this.props;

    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>Filtersatz anlegen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <hr class="m-t-0" />
          <div class="clearfix">
            <div class="pull-left m-r-5 bold">Gesetzte Filter:</div>
            {this.listFilters()}
          </div>
          <div class="input-group">
            <input
              class="form-control"
              type="text"
              name="filtersetInput"
              placeholder="Name für den Filtersatz eingeben ..."
              value={this.state.filtersetInput}
              onChange={e => this.setState({ filtersetInput: e.target.value })}
              disabled={formStatus.pending}
            />
            <span class="input-group-btn">
              <Button
                class="m-l-5"
                disabled={this.state.filtersetInput.length < 4 || formStatus.pending}
                type="submit"
                bsStyle="primary"
                onClick={() => {
                  this.saveButtonClicked(this.state.filtersetInput);
                }}
              >
                <i class={'fa-fw ' + (formStatus.pending ? ' fa fa-circle-notch fa-spin' : 'fas fa-save')} />{' '}
                {messages.save}
              </Button>
            </span>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(FiltersetNew)));
